import Vue from "vue";
import Router from "vue-router";
import serviceBuy from "@/pages/wrongbook/servicebuy";
import pic from "@/pages/pic/pic";
import tacitDetail from "@/pages/tacit/tacitDetail/tacitDetail";
import tacitResult from "@/pages/tacit/tacitResult/tacitDetail";
import normalDetail from "@/pages/normal/detail";
import normalResult from "@/pages/normal/result";
import rank from "@/pages/rank/rank";
import answerTacit from "@/pages/answer/answerTacit";
import answerNormal from "@/pages/answer/answerNormal";
import questionList from "@/pages/questionList/questionList";
import templateCenter from "@/pages/questionList/templateCenter";
import doNormal from "@/pages/normal/do";
import mIndex from "@/pages/index/mindex";
import terms from "@/pages/agreement/terms";
import privacy from "@/pages/agreement/privacy";
import vip from "@/pages/vip/vip";
import intro from "@/pages/intro/intro";
import createHelp from "@/pages/create/createHelp";
import enroll from "@/pages/enroll/enroll";
import loginFact from "@/pages/index/loginfact";
import resultTry from "@/pages/normal/resultTry";
import vipTest from "@/pages/vip/vipTest";
import awardsList from "@/pages/award/list";
import awardsDetail from "@/pages/award/detail";
import awardsAddress from "@/pages/award/address";
import awardsCash from "@/pages/award/cash";
import lottery from "@/pages/lottery/lottery";
import agreement from "@/pages/agreement/agreement";
import home from "@/pages/home/home";
import category from "@/pages/home/category";
import timer from '@/pages/timer/timer';
import timerRecord from '@/pages/timer/timerRecord';
import helpCenter from '@/pages/helpCenter/helpCenter';
import audit from '@/pages/normal/audit';
import detailPause from '@/pages/normal/detailPause';
import settingTip from '@/pages/helpCenter/settingTip';
import wrongbookList from '@/pages/wrongbook/wrongbooklist';
import OrgQs from '@/pages/orgQs/orgQs';
import Report from '@/pages/order/report';
import Complain from '@/pages/order/complain';
import Message from '@/pages/order/message';
import ComplainList from '@/pages/order/complainlist';
import Withdraw from '@/pages/order/withdraw';
import OrderList from '@/pages/order/orderlist';
import OrderDetail from '@/pages/order/orderdetail';
import ShareBox from '@/pages/share/sharebox';
import Demo from '@/pages/demo/demo'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: "/question/servicebuy",
      name: "serviceBuy",
      component: serviceBuy
    },
    {
      path: "/pic",
      name: "pic",
      component: pic
    },
    {
      path: "/tacit/tacitDetail",
      name: "tacitDetail",
      component: tacitDetail
    },
    {
      path: "/tacit/tacitResult",
      name: "tacitResult",
      component: tacitResult
    },
    {
      path: "/normal/normalResult",
      name: "normalResult",
      component: normalResult
    },
    {
      path: "/normal/detail",
      name: "normalDetail",
      component: normalDetail,
      // meta: { keepAlive: true }
    },
    {
      path: "/detail",
      name: "detail",
      component: normalDetail,
    },
    {
      path: "/enroll",
      name: "enroll",
      component: enroll
    },
    {
      path: "/rank",
      name: "rank",
      component: rank
    },
    {
      path: "/answer/answerTacit",
      name: "answerTacit",
      component: answerTacit
    },
    {
      path: "/answer/answerNormal",
      name: "answerNormal",
      component: answerNormal
    },
    // {
    //   path: "/questionList",
    //   name: "questionList",
    //   component: questionList,
    //   meta: { keepAlive: true }
    // },
    {
      path: "/templateCenter",
      name: "templateCenter",
      component: templateCenter,
      meta: { keepAlive: true }
    },
    {
      path: "/normal/do",
      name: "doNormal",
      component: doNormal,
      // meta: { keepAlive: true }
    },
    // {
    //   path: "/mindex",
    //   name: "mindex",
    //   component: questionList
    // },
    {
      path: "/terms",
      name: "terms",
      component: terms
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy
    },
    {
      path: "/vip",
      name: "vip",
      component: vip
    },
    {
      path: "/login",
      name: "login",
      component: mIndex,
      meta: { keepAlive: true }
    },
    {
      path: "/loginfact",
      name: "loginfact",
      component: loginFact
    },
    // {
    //   path: "/intro",
    //   name: "intro",
    //   component: intro,
    // },
    {
      path: "/createHelp",
      name: "createHelp",
      component: createHelp,
      meta: { keepAlive: false }
    },
    {
      path: "/normal/resultTry",
      name: "resultTry",
      component: resultTry
    },
    {
      path: "/vipTest",
      name: "vipTest",
      component: vipTest
    },
    {
      path: "/awardsList",
      name: "awardsList",
      component: awardsList
    },
    {
      path: "/awardsDetail",
      name: "awardsDetail",
      component: awardsDetail
    },
    {
      path: "/awardsAddress",
      name: "awardsAddress",
      component: awardsAddress
    },
    {
      path: "/awardsCash",
      name: "awardsCash",
      component: awardsCash
    },
    {
      path: "/lottery",
      name: "lottery",
      component: lottery
    },
    {
      path: "/agreement",
      name: "agreement",
      component: agreement
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: home,
    //   meta: { keepAlive: true }
    // },
    {
      path: "/category",
      name: "category",
      component: category
    },
    {
      path: "/timer",
      name: "timer",
      component: timer
    },
    {
      path: "/timerRecord",
      name: "timerRecord",
      component: timerRecord
    },
    {
      path: "/mindex",
      component: () => import("@/pages/layout/layout"),
      children: [
        {
          path: "",
          name: "home",
          component: () => import("@/pages/home/home"),
          meta: { keepAlive: true }
        },
        {
          path: "/intro",
          name: "intro",
          component: () => import("@/pages/intro/intro"),
          meta: { keepAlive: true }
        },
        {
          path: "/questionList", //首页是默认子路由，所谓为空
          name: "questionList",
          component: () => import("@/pages/questionList/questionList"),
          meta: { keepAlive: true }
        },
        {
          path: "/personal", //
          name: "personal",
          component: () => import("@/pages/personal/personal"),
          meta: { keepAlive: true }
        }
      ]
    },
    {
      path: '/helpCenter',
      name: 'helpCenter',
      component: helpCenter
    },
    {
      path: '/audit',
      name: 'audit',
      component: audit
    },
    {
      path: '/detailPause',
      name: 'detailPause',
      component: detailPause
    },
    {
      path: '/settingTip',
      name: 'settingTip',
      component: settingTip
    },
    {
      path: '/wrongbooklist',
      name: 'wrongbooklist',
      component: wrongbookList
    },
    {
      path: '/org_question',
      name: 'orgQuestion',
      component: OrgQs
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/complain',
      name: 'complain',
      component: Complain
    },
    {
      path: '/complainlist',
      name: 'complainlist',
      component: ComplainList
    },
    {
      path: '/message',
      name: 'message',
      component: Message
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: Withdraw
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: OrderList
    },
    {
      path: '/orderdetail',
      name: 'orderdetail',
      component: OrderDetail
    },
    {
      path: '/sharebox',
      name: 'sharebox',
      component: ShareBox
    },
    {
      path: '/demo',
      name: 'demp',
      component: Demo
    }
  ],
  mode: "history",
  // base: "/test/",
  scrollBehavior: () => ({
    y: 0
  })
});



// WEBPACK FOOTER //
// ./src/router/index.js